function AccountingJournalRecoveryGate({ route, setRoute, children }) {
  const backend = window.PlummeBackend.useBackend();
  const issue = window.PlummeAccountingJournalRecovery.getIssue(backend);
  const [busy, setBusy] = React.useState(false);
  if (!issue || (backend.appState?.activeYear && Number(backend.appState.activeYear) !== issue.year)) return children;
  const correctionYear = window.PlummeAccountingJournalRecovery.correctionYear(issue, backend.appState);
  const retry = async () => {
    setBusy(true);
    try { await backend.retryAccountingJournal?.(); } finally { setBusy(false); }
  };
  if (window.PlummeAccountingJournalRecovery.canReviewImportedOpening(issue)) {
    const openImport = () => {
      // Persist only the navigation preference, never accounting state.
      try { localStorage.setItem('plumme-innstillinger-tab', 'data'); } catch (_) { /* Navigation still works without local storage. */ }
      setRoute('innstillinger');
      window.dispatchEvent(new CustomEvent('plumme-settings-tab', { detail: 'data' }));
    };
    return <React.Fragment>
      <section className="card card-pad mb-16" role="status" aria-label={t('journalRecovery.setupTitle', { year: issue.year })}>
        <h2 className="t-h2">{t('journalRecovery.setupTitle', { year: issue.year })}</h2>
        <p>{t('journalRecovery.setupHelp', { year: issue.year })}</p>
        <Button onClick={openImport}>{t('journalRecovery.continueImport')}</Button>
        <window.ImportedOpeningRecovery key={`${issue.businessId}:${issue.year}`} issue={issue} onRecovered={retry}/>
      </section>
      {children}
    </React.Fragment>;
  }
  return <React.Fragment>
    <section className="card card-pad mb-16" style={{ overflowWrap: 'anywhere' }} role="alert" aria-label={t('journalRecovery.title')}>
      <h2 className="t-h2">{t(correctionYear ? 'journalRecovery.correctionTitle' : 'journalRecovery.title', { year: correctionYear })}</h2>
      <p>{t(correctionYear ? 'journalRecovery.correctionHelp' : 'journalRecovery.description', { year: correctionYear, sourceYear: correctionYear - 1 })}</p>
      {correctionYear && <window.ImportedOpeningRecovery key={`${issue.businessId}:${correctionYear}:correction`} issue={{ ...issue, year: correctionYear }} correction onRecovered={retry}/>}
      <details className="mt-16 mb-16">
        <summary>{t('journalRecovery.supportDetails')}</summary>
        <p className="text-muted">{t('journalRecovery.reference', { businessId: issue.businessId, year: issue.year })}</p>
        <p><code>{issue.reasonCodes.join(', ')}</code></p>
      </details>
      <div className="flex gap-12" style={{ flexWrap: 'wrap' }}>
        <Button onClick={retry} disabled={busy}>{t(busy ? 'journalRecovery.retrying' : 'journalRecovery.retry')}</Button>
        {route !== 'support' && <Button variant="secondary" onClick={() => setRoute('support')}>{t('journalRecovery.support')}</Button>}
        <Button variant="secondary" onClick={() => window.PlummeBackend.signOut()}>{t('journalRecovery.signOut')}</Button>
      </div>
    </section>
    {route === 'support' ? children : null}
  </React.Fragment>;
}
Object.assign(window, { AccountingJournalRecoveryGate });
